import { translationKey } from '../i18n';
const preciseQuantity = value => Number.isFinite(value) && /^\d+(\.\d{1,2})?$/.test(String(value));

export function stockSnapshot(med) {
    return { totalStock: med.totalStock ?? null, remainingStock: med.remainingStock ?? null,
        dosagePerTime: med.dosagePerTime ?? 1, stockAlertThreshold: med.stockAlertThreshold ?? 3,
        stockBaselineId: med.stockBaselineId ?? null };
}

export function stockErrors(form) {
    const errors = {};
    const total = Number(form.totalStock);
    const remaining = Number(form.remainingStock);
    const threshold = Number(form.stockAlertThreshold);
    if (!String(form.totalStock).trim() || !preciseQuantity(total) || total <= 0 || total > 9999)
        errors.totalStock = translationKey('총 수량은 0.01~9,999 사이로 소수 둘째 자리까지 입력해주세요');
    if (form.remainingStock !== '' && (!preciseQuantity(remaining) || remaining < 0))
        errors.remainingStock = translationKey('남은 수량은 0 이상, 소수 둘째 자리까지 입력해주세요');
    else if (form.remainingStock !== '' && !errors.totalStock && remaining > total)
        errors.remainingStock = translationKey('남은 수량은 총 수량보다 많을 수 없어요');
    if (String(form.stockAlertThreshold).trim() === '' || !Number.isInteger(threshold) || threshold < 0 || threshold > 9999)
        errors.stockAlertThreshold = translationKey('알림 기준은 0~9,999 사이의 정수로 입력해주세요');
    return errors;
}
